<div class="row">
	<label class="col-md-4 col-form-label">Browse to upload a file</label>
	<div class="col-md-8">
		@if (!isUploading) {
			<label class="button green">
				Upload files
				<input (change)="PerformUpload($event)" type="file" class="form-control-file" multiple>
			</label>
		}
		@if (isUploading) {
			<button class="button green" disabled>
				Uploading...
			</button>
		}
	</div>
</div>
<div>
	@if (uploadSuccess) {
		<span class="message-good">{{uploadSuccess}}</span>
	}
	@if (uploadError) {
		<span class="message-bad">{{uploadError}}</span>
	}
</div>

@if (listing === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading...
	</div>
}

@if (listing && listing.files.length === 0 && listing.directories.length === 0) {
	<div class="loading-status">
		No datafiles found.
	</div>
}

@if (listing && (listing.files.length > 0 || listing.directories.length > 0)) {
	<div class="mt-3">
		<h5>Files in S3</h5>
		<div class="directories">
			<!-- Note: currently this only supports 1 deep which should be all we ever have. But we'll show the directories anyway -->
			@for (dir of listing.directories; track dir) {
				<div class="listing-item">
					<i class="icon-folder"></i> {{dir}}
				</div>
			}
		</div>
		<div class="files">
			@for (file of listing.files; track file) {
				<div class="listing-item">
					<a (click)="DownloadFile(file)" href="javascript:void(0)"><i class="icon-doc"></i> {{file}}</a>
					<app-action-button [action]="DeleteFile" [args]="[file]" [context]="this" title="Delete file" btnClass="icon red" confirm="Delete this file from the control bucket?"
						processing="..."><i class="icon-trash"></i></app-action-button>
				</div>
			}
		</div>
	</div>
}